import {useDispatch, useSelector} from "react-redux";
import {mobileMenuActions} from "Framework/redux/actions/index";
import {Burger, BurgerButtonWrapper} from "./BurgerButtonWrapper";
import React from "react";

export const HamburgerButton = ({ text, url }) => {
	const state = useSelector(({ mobileMenu }) => mobileMenu);
	const dispatch = useDispatch();

	let handleClick = (e) => {
		e.preventDefault();
		dispatch(mobileMenuActions.toggle(state.show));
	};
	let className = state.show ? "open" : "";

	return (
		<Burger>
			<BurgerButtonWrapper onClick={(e) => handleClick(e)}>
				<span className={className}></span>
				<span className={className}></span>
				<span className={className}></span>
				<span className={className}></span>
			</BurgerButtonWrapper>
		</Burger>
	);
};
